import CostLine from './CostLine';
import { ExternalReview } from './ExternalReview';
import { SupportingDocument } from './supporting-document';
import { DigitisationStatus } from '../values/DigitisationStatus';

export default class Invoice {
    public readonly key?: string;
    public readonly date?: Date;
    public readonly number?: string;
    public readonly taxIdNumber?: string;
    public readonly providerName?: string;
    public readonly discountInCents?: number;
    public readonly supportingDocument: SupportingDocument;
    public readonly costLines: CostLine[];
    public readonly digitisationStatus?: DigitisationStatus;
    public readonly updatedAt?: Date;
    public readonly externalReview?: ExternalReview;
    public readonly currency: string;

    constructor({
        key,
        date,
        number,
        taxIdNumber,
        providerName,
        discountInCents,
        supportingDocument,
        costLines,
        digitisationStatus,
        updatedAt,
        externalReview,
        currency = 'EUR',
    }: {
        key?: string;
        date?: Date;
        number?: string;
        taxIdNumber?: string;
        providerName?: string;
        discountInCents?: number;
        supportingDocument: SupportingDocument;
        costLines: CostLine[];
        digitisationStatus?: DigitisationStatus;
        updatedAt?: Date;
        externalReview?: ExternalReview;
        currency?: string;
    }) {
        this.key = key;
        this.date = date;
        this.number = number;
        this.taxIdNumber = taxIdNumber;
        this.providerName = providerName;
        this.discountInCents = discountInCents;
        this.supportingDocument = supportingDocument;
        this.costLines = costLines;
        this.digitisationStatus = digitisationStatus;
        this.updatedAt = updatedAt;
        this.externalReview = externalReview;
        this.currency = currency;
    }

    get isDigitalised(): boolean {
        return this.costLines.length !== 0;
    }
}
